import React from 'react';
import { createCommand, Option } from '@commander-js/extra-typings';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import type { CommandServices } from '@wix/cli-command-contract';
import { renderCommand, runCommand } from './render-command.js';

export const envPullCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('pull')
    .description(
      'Pulls environment variables and merge them into .env.local file'
    )
    .addOption(
      new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format').hideHelp()
    )
    .action(async (opts, command) => {
      if (opts.json) {
        return runCommand(command, services, cliVersion, async (model) => {
          const { nonInteractiveEnvPull } = await import(
            '../non-interactive/env-pull.js'
          );
          return nonInteractiveEnvPull(services, model);
        });
      }

      const { EnvPullCommand } = await import(
        '../components/EnvPullCommand/index.js'
      );

      await renderCommand(command, services, cliVersion, <EnvPullCommand />);
    });
};
